"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin for management apparatus API calls.
 */
var ApparatusMixin = /** @class */ (function () {
    function ApparatusMixin() {
    }
    /**
     * Retrieve all apparatus for an agency w/ pagination
     * @param agencyId
     * @param limit
     * @param page
     * @param search
     * @param sortConfig
     * @param callback
     */
    ApparatusMixin.prototype.getApparatus = function (agencyId, limit, page, search, sortConfig, callback) {
        var _this = this;
        var urlParams = {
            limit: limit,
            page: page,
            sortBy: sortConfig.column,
            order: sortConfig.direction,
        };
        if (search != null) {
            urlParams.search = search;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'clients', models_1.Apparatus.parse); }));
        };
        this.http.get("/agencies/".concat(agencyId, "/apparatus"), urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create an apparatus account in an agency
     * @param agencyId
     * @param name
     * @param apparatusId
     * @param apparatusType
     * @param password
     * @param callback
     */
    ApparatusMixin.prototype.createApparatusInAgency = function (agencyId, name, apparatusId, apparatusType, password, callback) {
        var _this = this;
        var body = {
            name: name,
            apparatusId: apparatusId,
            apparatusType: models_1.ApparatusTypeEnum[apparatusType],
            password: password,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Apparatus.parse));
        };
        this.http.post("/agencies/".concat(agencyId, "/apparatus"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an apparatus account by ID
     * @param agencyId
     * @param apparatusId
     * @param callback
     */
    ApparatusMixin.prototype.getSpecificApparatus = function (agencyId, apparatusId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Apparatus.parse));
        };
        this.http.get("/agencies/".concat(agencyId, "/clients/").concat(apparatusId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Update an apparatus account's common info by ID
     * @param apparatusId
     * @param name
     * @param apparatusShortId
     * @param apparatusType
     * @param callback
     */
    ApparatusMixin.prototype.updateApparatusInfo = function (apparatusId, name, apparatusShortId, apparatusType, callback) {
        var _this = this;
        var body = {
            name: name,
            apparatusId: apparatusShortId,
            apparatusType: apparatusType != null ? models_1.ApparatusTypeEnum[apparatusType] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Apparatus.parse));
        };
        this.http.put("/apparatus/".concat(apparatusId), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Set a passsword for an apparatus account by ID
     * @param apparatusId
     * @param password
     * @param callback
     */
    ApparatusMixin.prototype.setApparatusPassword = function (apparatusId, password, callback) {
        var _this = this;
        var body = { password: password };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/apparatus/".concat(apparatusId, "/password"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return ApparatusMixin;
}());
exports.default = ApparatusMixin;
//# sourceMappingURL=ApparatusMixin.js.map